export default "__VITE_ASSET__wbLmX3gD__"